import { render, staticRenderFns } from "./TheResearchBonus.vue?vue&type=template&id=760ba4f0&scoped=true&"
import script from "./TheResearchBonus.vue?vue&type=script&lang=js&"
export * from "./TheResearchBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ba4f0",
  null
  
)

export default component.exports